module.exports = __webpack_public_path__ + "img/7.f2d1a56a.png";